<div class="ppp">
  <input #fileInput type="file" accept="image/*" hidden (change)="onFileSelected($event)">

  <!-- Vista normal: el cuadro del paciente y las acciones -->
  <div class="ppp-row" *ngIf="!isCropping">
    <app-patient-avatar [name]="name" [lastName]="lastName" [photoUrl]="shownPhotoUrl" [size]="72"></app-patient-avatar>
    <div class="ppp-actions">
      <span class="ppp-label">Foto del paciente <span class="ppp-optional">(opcional)</span></span>
      <div class="ppp-buttons">
        <button type="button" mat-button class="ppp-btn" (click)="openFilePicker()">
          <mat-icon>photo_camera</mat-icon>{{ shownPhotoUrl ? 'Cambiar foto' : 'Subir foto' }}
        </button>
        <button type="button" mat-button class="ppp-btn ppp-btn-ghost" *ngIf="shownPhotoUrl" (click)="removePhoto()">
          <mat-icon>delete_outline</mat-icon>Quitar
        </button>
      </div>
    </div>
  </div>

  <!-- Recorte: siempre cuadrado, con zoom -->
  <div class="ppp-cropper" *ngIf="isCropping">
    <p class="ppp-hint">Mueve el cuadro y usa el zoom para encuadrar la cara del paciente.</p>

    <div class="ppp-stage">
      <image-cropper
        [imageFile]="sourceFile"
        [maintainAspectRatio]="true"
        [aspectRatio]="1"
        [resizeToWidth]="outputSize"
        [onlyScaleDown]="true"
        [allowMoveImage]="true"
        [transform]="transform"
        [imageQuality]="85"
        backgroundColor="#ffffff"
        format="jpeg"
        (imageCropped)="onImageCropped($event)"
        (loadImageFailed)="onLoadImageFailed()">
      </image-cropper>
    </div>

    <div class="ppp-zoom">
      <button type="button" mat-icon-button class="ppp-zoom-btn" (click)="zoomBy(-0.25)" [disabled]="transform.scale <= minZoom" aria-label="Alejar">
        <mat-icon>remove</mat-icon>
      </button>
      <mat-slider class="ppp-slider" [min]="minZoom" [max]="maxZoom" step="0.05" [value]="transform.scale" (input)="onZoomChange($event.value)" aria-label="Zoom"></mat-slider>
      <button type="button" mat-icon-button class="ppp-zoom-btn" (click)="zoomBy(0.25)" [disabled]="transform.scale >= maxZoom" aria-label="Acercar">
        <mat-icon>add</mat-icon>
      </button>
    </div>

    <div class="ppp-crop-actions">
      <button type="button" mat-button class="button info-button" (click)="cancelCrop()">Cancelar</button>
      <button type="button" mat-button class="button secondary-button" (click)="confirmCrop()" [disabled]="!lastCrop">Usar foto <mat-icon>check</mat-icon></button>
    </div>
  </div>

  <p class="ppp-error" *ngIf="errorMessage">{{ errorMessage }}</p>
</div>
